import { useMemo, useState } from "react";

const axes = [
  ["platform-modernization", "Platform Modernization", "Are data platforms scalable, observable, and decoupled from legacy friction?"],
  ["semantic-coherence", "Semantic Coherence", "Do models and teams share verified, unambiguous metric definitions?"],
  ["ai-ml-governance", "AI/ML Governance", "Are model recommendations auditable with documented human override boundaries?"],
  ["decision-memory", "Decision Memory", "Does the organization preserve the evidence and assumptions behind consequential choices?"],
  ["outcome-learning", "Outcome Learning", "Is outcome variance tracked to refine data contracts, models, and workflows?"],
];

export default function MaturityMatrix() {
  const [values, setValues] = useState([2, 2, 3, 2, 2]);
  const score = useMemo(() => Math.round((values.reduce((sum, value) => sum + value, 0) / 25) * 100), [values]);

  return (
    <div className="matrix-wrap" data-testid="maturity-matrix">
      <div className="matrix-top">
        <div>
          <div className="section-kicker">Orientation tool / 02</div>
          <h2 className="matrix-title">Where does the data-to-decision system stand?</h2>
        </div>
        <p className="matrix-caption">Move each axis to sketch a conversation. This is a prompt for inquiry, not a benchmark or certification.</p>
      </div>
      <div className="matrix-axes">
        {axes.map(([id, label, prompt], index) => (
          <label className="matrix-axis" key={id} htmlFor={`maturity-axis-${id}`}>
            <span className="matrix-axis-copy"><strong>{label}</strong><small>{prompt}</small></span>
            <input id={`maturity-axis-${id}`} type="range" min="1" max="5" value={values[index]} data-testid={`maturity-axis-${id}`} onChange={(event) => setValues((current) => current.map((value, itemIndex) => itemIndex === index ? Number(event.target.value) : value))} />
            <span className="matrix-axis-value">{values[index]} / 5</span>
          </label>
        ))}
      </div>
      <div className="matrix-score" data-testid="maturity-matrix-score-output">
        <span className="matrix-score-number">{score}</span>
        <span><strong>data-to-decision readiness sketch</strong><small>A higher score suggests more of the surrounding system is ready to be made explicit.</small></span>
      </div>
    </div>
  );
}
